import Img from './ResetImg.svg';
import React from 'react';
import {
  Modal,
} from '@mayo/mayo-ui-gakki';

type DeleteDialogProps = {
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen?: boolean;
  text?: React.ReactNode;
  title?: string;
  disabled?: boolean;
};
export default function ResetDialog(props: DeleteDialogProps) {
  const {text, isOpen, onCancel, onConfirm, title, disabled} = props;

  return (
    <Modal
      className={'reset-dialog'}
      modalLabel="reset-dialog"
      isOpen={isOpen}
      size="md"
      modalTitle={title || '全部重設'}
      onTitleClose={onCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
      disabled={disabled}
    >
      <div className="flex justify-between">
        <div className="pt-8 pl-4">
          {text ? (
            text
          ) : (
            <span>
              點選確定重置後，您所建立的資料將全數清除
              <br />
              且不可復原，請問依舊要重置嗎?
            </span>
          )}
        </div>
        <img
          alt="resetImg"
          src={Img}
          className="pt-[15px] pr-[75px]"
        />
      </div>
    </Modal>
  );
}
